var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgLine = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.52454 9.4024V5.75955H9.35835V8.55202H10.9245V9.4024H8.52454Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.519572 7.51483C0.140907 12.6981 5.34676 14.7216 8.33185 14.9489C8.33185 14.9489 8.97727 15.0693 8.91004 15.7111C8.89056 16.1114 8.82089 16.4682 8.76769 16.7405C8.71074 17.0321 8.67267 17.227 8.73524 17.2754C8.8697 17.5428 9.14418 17.5295 9.35377 17.4492C15.6601 14.1734 18.8445 11.2206 18.4704 7.51483C18.0979 2.05319 13.0884 0.362382 9.52862 0.508612C2.71128 0.508617 0.514999 5.31053 0.519572 7.51483ZM8.52454 5.75955V9.4024H10.9245V8.55202H9.35835V5.75955H8.52454Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.52454 9.4024V5.75955H9.35835V8.55202H10.9245V9.4024H8.52454Z",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.519572 7.51483C0.140907 12.6981 5.34676 14.7216 8.33185 14.9489C8.33185 14.9489 8.97727 15.0693 8.91004 15.7111C8.89056 16.1114 8.82089 16.4682 8.76769 16.7405C8.71074 17.0321 8.67267 17.227 8.73524 17.2754C8.8697 17.5428 9.14418 17.5295 9.35377 17.4492C15.6601 14.1734 18.8445 11.2206 18.4704 7.51483C18.0979 2.05319 13.0884 0.362382 9.52862 0.508612C2.71128 0.508617 0.514999 5.31053 0.519572 7.51483ZM8.52454 5.75955V9.4024H10.9245V8.55202H9.35835V5.75955H8.52454Z",
    stroke: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLine, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Line.ce5e672b.svg";
export { ForwardRef as ReactComponent };